import Styled from 'styled-components';

const HrStyled = Styled.hr`
  position: relative;
  display: block;
  border: none;
  border-bottom: 1px solid #e8e8e8;
  margin-left: 15px;
`;

export default HrStyled;
export { HrStyled };
